import "./style.css";

export default class ResetPassword {
  static selector = ".s-reset-password";

  constructor(block) {
    this.block = block;
    this.$signInButton = block.querySelector(".s-button__gradient.s-button");
    this.$signIn = block.querySelector(".s-button__reset a");

    this.$password = block.querySelector("#s-password");
    this.$repeatPassword = block.querySelector("#s-repeat-password");
    this.$strength1 = block.querySelector("#strength1");
    this.$strength2 = block.querySelector("#strength2");
    this.$thankYouSignIn = block.querySelector(".s-button__sign-in a");
  }

  onSignIn(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $form = document.body.querySelector("form#resetpassform");
    const $pass1 = $form.querySelector("input#pass1");
    const $pass2 = $form.querySelector("input#pass2");
    $pass1.value = this.$password.value;
    $pass2.value = this.$repeatPassword.value;
    $form.querySelector('input[type="submit"]').click();

    // window.__$user && window.__$user.click();
  }

  onThankYouSignIn(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.__$user && window.__$user.click();
  }

  setStrength($el, strength) {
    this.totalStrength = strength;
    const label = $el.querySelector("label");
    const bar = $el.querySelector(".s-strength__bar");

    label.innerHTML = "&nbsp;";
    bar.classList.remove("level1");
    bar.classList.remove("level2");
    bar.classList.remove("level3");

    if (strength >= 0 && strength <= 1) {
      label.innerHTML = "WEAK";
      bar.classList.add("level1");
    } else if (strength >= 2 && strength <= 3) {
      label.innerHTML = "MEDIUM";
      bar.classList.add("level2");
    } else if (strength >= 4) {
      label.innerHTML = "STRONG";
      bar.classList.add("level3");
    }
  }

  onPasswordChange($input, $str, e) {
    if ($input.value.length >= 12) {
      const strength = wp.passwordStrength.meter(
        $input.value,
        [],
        $input.value
      );
      this.setStrength($str, strength);
    } else {
      this.setStrength($str, -1);
    }

    this.onValidatePassword.bind(this)();
  }

  onValidatePassword() {
    let disabled = true;
    if (
      this.$password.value.length >= 12 &&
      this.$repeatPassword.value.length >= 12
    ) {
      if (
        this.$password.value === this.$repeatPassword.value &&
        this.totalStrength >= 4
      ) {
        disabled = false;
      }
    }

    if (disabled) this.$signInButton.setAttribute("disabled", "disabled");
    else this.$signInButton.removeAttribute("disabled");
  }

  addListeners() {
    // test
    if (this.$signIn) {
      this.$signIn.addEventListener("click", this.onSignIn.bind(this));

      this.$password.addEventListener(
        "keyup",
        this.onPasswordChange.bind(this, this.$password, this.$strength1)
      );

      this.$repeatPassword.addEventListener(
        "keyup",
        this.onPasswordChange.bind(this, this.$repeatPassword, this.$strength2)
      );
    }

    if (this.$thankYouSignIn) {
      this.$thankYouSignIn.addEventListener(
        "click",
        this.onThankYouSignIn.bind(this)
      );
    }
  }

  onReady() {
    this.addListeners();
  }
}
